import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tennis',
  templateUrl: './tennis.component.html',
  styleUrls: ['./tennis.component.scss'],
})
export class TennisComponent implements OnInit {
  title = 'app-tennis';

  ngOnInit(): void {}
}
